import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, ButtonGroup, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { MenuMultiSelectItem, SearchableMenu } from 'shared/domains/common-ui/SearchableMenu';
import { useSearchContext } from '../SearchProvider';
export function AddFilterButton(props) {
    const { filterItems } = props;
    const { hasFilters, clearFilters, toggleFilter, activeFilters } = useSearchContext();
    if (filterItems.length === 0)
        return null;
    return (<ButtonGroup>
      <SearchableMenu items={filterItems} keys={['name']} placeholder={t({
            message: 'Search',
            comment: 'Search filters: Filter selection search input',
        })} renderTarget={<Button type="button" size="small" appearance="secondary">
            <Falcon icon="plus"/>
            <Trans comment="Search: Add filter menu button">Filters</Trans>
          </Button>}>
        {({ items }) => items.map((item) => (<MenuMultiSelectItem key={item.id} selected={activeFilters.includes(item.id)} onClick={() => toggleFilter(item.id)}>
              {item.name}
            </MenuMultiSelectItem>))}
      </SearchableMenu>
      {hasFilters && (<IconButton appearance="secondary" size="small" onClick={clearFilters} aria-label={t({ message: 'Remove all filters', comment: 'Filters: Clear all filters' })}>
          <Falcon icon="remove"/>
        </IconButton>)}
    </ButtonGroup>);
}
